'use client'

import { useSession } from '@marketplace-web/shared/session'

import TrackScreen from '../TrackScreen'

const SessionTrackScreen = () => {
  const { screen } = useSession()

  return <TrackScreen screen={screen} />
}

export default SessionTrackScreen
